import * as React from 'react';
import { SVGProps } from 'react';

const IconClearSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 11A5 5 0 1 0 6 1a5 5 0 0 0 0 10ZM3.177 8.819c.237.236.62.236.857 0l1.964-1.964 1.968 1.968a.606.606 0 0 0 .857-.856L6.854 5.999l1.967-1.966a.605.605 0 1 0-.857-.856L5.998 5.143 4.034 3.179a.606.606 0 0 0-.857.856L5.142 6 3.177 7.963a.605.605 0 0 0 0 .856Z"
    />
  </svg>
);
export default IconClearSizeXs;
